<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">请假</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body"  :style="bodyStyle">
                <div>
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="name" clearable @change="getList(true)" style="margin:0 10px;width:200px"></el-input>
                        <el-input  placeholder="请输入身份证号" v-model="idCard" clearable @change="getList(true)" style="margin-right:10px;width:200px"></el-input>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                    </div>
                    <div style="clear: both;"></div>
                </div>
                <div style="height: 10px;"></div>
                <div>
                    <el-table ref="historicalFilesTable" :data="tableData" v-loading="loading" :height="th" border style="width: 100%;">
                        <el-table-column label="老人姓名" prop="name" width="100"></el-table-column>
                        <el-table-column label="手机号" prop="phone" width="120"></el-table-column>
                        <el-table-column label="身份证号" prop="idCard" width="180"></el-table-column>
                        <el-table-column prop="balance"  width="100" label="余额(元)"></el-table-column>
                        <el-table-column prop="deposit"  width="100" label="预交金(元)"></el-table-column>
                        <el-table-column prop="imprest"  width="100" label="备用金(元)"></el-table-column>
                        <el-table-column prop="checkinList" label="入住状态">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.checkinStatus==1" type="primary">入住中</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="地址" prop="areaName" ></el-table-column>
                        <el-table-column label="详细住址" prop="address" ></el-table-column>
                        
                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="success" size="small" @click="handleLevel(scope.row)">请假</el-button>
                            </template>
                        </el-table-column>

                    </el-table>
                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="请假" :visible.sync="dialogVisible" :modal-append-to-body='false' top="25vh" width="800px" :before-close='beforeClose'>
            <el-form :model="addForm" :rules="rules" ref="addForm">
                <el-row>
                    <el-col :span="12" class="item">
                        <el-form-item label="请假开始时间" required prop="startTime">
                            <el-date-picker
                                v-model="addForm.startTime"
                                type="datetime"
                                style="width:100%;"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :default-value="new Date()"
                                placeholder="请假开始时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                        <el-form-item label="预计结束时间" required prop="endTime">
                            <el-date-picker
                                v-model="addForm.endTime"
                                type="datetime"
                                style="width:100%;"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                default-time="23:59:59"
                                placeholder="预计结束时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" class="item">
                        <el-form-item label="委托人姓名" required prop="bailorName">
                            <el-input v-model="addForm.bailorName"  placeholder="委托人姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                        <el-form-item label="委托人电话" required prop="bailorPhone">
                            <el-input v-model="addForm.bailorPhone" maxlength="11"  placeholder="委托人电话"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="item">
                        <el-form-item label="请假原因" required prop="remarks">
                            <el-input v-model="addForm.remarks" type="textarea"  placeholder="请假原因"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="buttonLoading" @click="confirm('addForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props:['dishesList'],
        data() {
            return {
                buttonLoading:false,
                loading: false,
                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                showReport:true,
                row:null,
                showModalReport:false,
                dialogVisible: false,
                gridData:null,
                isCheck:0,
                dayNumber:0,
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    checkinCode:'',
                    bailorName:'',
                    bailorPhone:'',
                    startTime:"",
                    endTime:'',
                    remarks:''
                },
                bodyStyle:"height:"+(this.$store.state.tableHeight+40)+'px',
                th:this.$store.state.tableHeight,
                // pickerOptions0: { 
                //     disabledDate(time) {
                //         return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的 
                //     }
                // },
                name:'',
                isCard:'',
                rules:{
                    endTime:[
                        { required: true, message: '请选择预计结束时间', trigger: 'blur' },
                    ],
                    startTime:[
                        { required: true, message: '请选择请假开始时间', trigger: 'blur' },
                    ],
                    bailorName:[
                        { required: true, message: '请输入委托人姓名', trigger: 'blur' },
                    ],
                    bailorPhone:[
                        { required: true, message: '请输入委托人电话', trigger: 'blur' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号'
                        },
                    ],
                    remarks:[
                        { required: true, message: '请输入请假原因', trigger: 'blur' },
                    ]
                }
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.bodyStyle = "height:"+(val+40)+'px';
                this.th=val
            },
        },
        components:{
        },
        methods: {
            init(){
                this.getList()
            },
            beforeClose(done){
                this.$refs.addForm.resetFields();
                done();
            },
            handleLevel(row){
                this.row = row;
                this.addForm.elderlyCode = row.elderlyCode;
                this.addForm.checkinCode = row.checkinCode;
                this.dialogVisible=true
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/GetListByCheckinStatus",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        isCard:'',
                        checkinStatus:1,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        this.$nextTick(()=>{
                            this.$refs.historicalFilesTable.doLayout()
                        })
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            closeSelf() {
                this.$emit("closeLeave");
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        if(this.addForm ==""){
                            this.$message({type: 'info', message: '菜单不能为空'});
                            return ;
                        }
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            addSubmit(){
                if(this.buttonLoading){
                    return;
                }else{
                    this.buttonLoading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RefundSettle/Add",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.buttonLoading = false;
                        this.dialogVisible=false
                        if (response.data.error == 0) {
                            this.$emit("closeLeave");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

   .modal-goodslist {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
